export enum FontName {
    GoogleSansBold = 'Google Sans Bold',
    PoppinsMedium = 'Poppins Medium',
    PoppinsSemiBold = 'Poppins-SemiBold',
    MontserratBold = 'Montserrat-Bold',
    PoppinsLight = 'Poppins-Light',
    RobotoLight = 'Roboto-Light',
    PoppinsRegular = 'Poppins-Regular',
    RobotoBold = 'Roboto-Bold',
    RobotoMedium = 'Roboto-Medium',
    RobotoRegular = 'Roboto-Regular',
    PoppinsBold = 'Poppins-Bold',
  }
  